import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['cta - button'],
    never_show_button: ['close - button']
  }
};

const TransparentBottomSheetTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        background: 'none'
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          alignItems: 'end',
          gap: '20px',
          paddingBottom: '50px'
        }}
      >
        <div>
          <EditTracking value={tracking?.button?.[0]} type="button" />
        </div>
        <div>
          <EditTracking
            value={tracking?.never_show_button?.[0]}
            type="never_show_button"
          />
        </div>
      </div>
    </div>
  );
};

export default TransparentBottomSheetTracking;
